import { render, staticRenderFns } from "./btn-download.vue?vue&type=template&id=0b8edcec&scoped=true"
import script from "./btn-download.vue?vue&type=script&lang=js"
export * from "./btn-download.vue?vue&type=script&lang=js"
import style0 from "./btn-download.vue?vue&type=style&index=0&id=0b8edcec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8edcec",
  null
  
)

export default component.exports